import React from 'react'
import CenterModal from '../../../components/Modals/center-modal'
import SmallCenterModal from '../../../components/Modals/small-center-modal'
import { ReactComponent as LocationIcon } from '../../../assets/icons/location.svg';
import { ReactComponent as TokenIcon } from '../../../assets/icons/token.svg';
import { ReactComponent as TokenExpireIcon } from '../../../assets/plus_icon/token_expire.svg'
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import { ReactComponent as PendingIcon } from '../../../assets/plus_icon/incentive_pending.svg';
import { ReactComponent as PaidIcon } from '../../../assets/plus_icon/incentive_paid.svg';
import { ReactComponent as CallingIcon } from '../../../assets/icons/calling.svg'
import { toINRFormat } from '../../../helpers/helpers';
import moment from 'moment';
import { ReactComponent as RightIcon } from '../../../assets/icons/righticon_primary.svg';

const TokenDetailsModal = ({ show, closeModal, selectedLead, setSelectedTimelineLead, setShowTimeline }) => {
    console.log(selectedLead, 'selectedLead')
    return (
        <SmallCenterModal show={show} closeModal={closeModal} modalClass='w-[400px]'>
            <div className='!p-6'>
                <div className='flex items-center justify-between !mb-4'>
                    <div className='h-12 w-12 rounded-xl bg-[#5256FB] flex items-center justify-center'>
                        <TokenIcon className='fill-white h-6 w-6' />
                    </div>
                    {/* <div className='h-12 w-12 rounded-xl bg-[#FF974A] flex items-center justify-center'>
                        <TokenExpireIcon className='fill-white h-6 w-6' />
                    </div> */}
                    <button className='border-0 bg-tr ' onClick={closeModal}><CloseIcon /></button>
                </div>
                <h3 className='text-lg font-semibold'>Token Details</h3>
                <div className='border rounded-xl !py-2 !px-4'>
                    <div className='flex justify-between items-center text-sm !mt-3' >
                        <span className='text-black700'>Project</span>
                        <span>{selectedLead?.site_visits[0]?.project_name || '-'}</span>
                    </div>
                    <div className='border-t !my-4'></div>
                    <div className='flex justify-between items-center text-sm'>
                        <span className='text-black700'>EOI Date & Time</span>
                        <span>{selectedLead?.site_visits[0]?.eoi_date ? moment(selectedLead?.site_visits[0]?.eoi_date).format('hh:mm a Do MMM YYYY') : '-'}</span>
                    </div>
                    <div className='border-t !my-4'></div>
                    {selectedLead?.site_visits[0]?.tagging_validity > 10 &&
                        <>
                            <div className='flex justify-between items-center text-sm'>
                                <span className='text-black700'>Tagging validity</span>
                                <span className='text-xs text-[#684EFB] bg-[#684EFB1A]/10 !py-1 px-2.5 font-bold rounded-2xl'>
                                    {selectedLead?.site_visits[0]?.tagging_validity} {selectedLead?.site_visits[0]?.tagging_validity_unit}
                                </span>
                            </div>
                            <div className='border-t !my-4'></div>
                        </>
                    }

                    {selectedLead?.tagging_validity > 0 && selectedLead?.tagging_validity < 10 && <>
                        <div className='flex justify-between items-center text-sm'>
                            <span className='text-black700'>Tagging validity</span>
                            <span className='text-xs text-[#D39E36] bg-[#D39E36]/15 !py-1 px-2.5 font-bold rounded-2xl'>
                                Expiring on {moment(selectedLead.tag_expiry_date).format('Do MMM YYYY')}
                            </span>
                        </div>
                        <div className='border-t !my-4'></div>
                    </>
                    }

                    {!selectedLead?.site_visits[0]?.tagging_validity && selectedLead?.site_visits[0]?.tag_expiry_date && <>
                        <div className='flex justify-between items-center text-sm'>
                            <span className='text-black700'>Tagging validity</span>
                            <span className='text-xs text-red bg-[#FF974A1A]/10 !py-1 px-2.5 font-bold rounded-2xl'>
                                Expired on {moment(selectedLead?.site_visits[0]?.tag_expiry_date).format('Do MMM YYYY')}
                            </span>
                        </div>
                        <div className='border-t !my-4'></div>
                    </>
                    }


                    <div className='flex justify-between items-center text-sm'>
                        <span className='text-black700'>Preferred unit</span>
                        <span className=''>
                            {selectedLead?.site_visits[0]?.unit_congiguration || '-'}
                        </span>
                    </div>
                    <div className='border-t !my-4'></div>
                    <div className='flex justify-between items-center text-sm !mb-4'>
                        <span className='text-black700'>EOI Amount</span>
                        <span className=''>
                            {selectedLead?.site_visits[0]?.token_amount ? `₹ ${toINRFormat(selectedLead?.site_visits[0]?.token_amount)}` : '-'}
                        </span>
                    </div>
                    {/* <div className='border-t !my-4'></div> */}
                    <div className='border-t !my-4'></div>
                    <div className='flex justify-center items-center'>
                        <button className='text-blue-900 font-semibold text-xs flex items-center' onClick={() => {
                            setSelectedTimelineLead(selectedLead);
                            setShowTimeline(true);
                            closeModal();
                        }}>
                            Show SV Timeline
                            <RightIcon className='fill-primary' />
                        </button>
                    </div>
                </div>
                <div className=' !mt-8'>
                    <button className='w-full border rounded-xl py-2.5 flex items-center justify-center'>
                        {/* <span>
                            <CallingIcon />
                        </span> */}
                        Call your SM
                    </button>

                </div>
            </div>
        </SmallCenterModal>
    )
}

export default TokenDetailsModal